// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"EmptyState_emptyState__gzNRA","tight":"EmptyState_tight__3A98t"};